export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "delete_confirm_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収拠点を削除しますか？"])}
    }
  })
}
